/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/

import {
  isAnyObjectSelected
} from './../utils/common';

const locationsModalTemplate = `
    <div class="row">
        <div class="col-md-12 text-left" ng-show="!editLocations">
            <button class="btn btn-line-info" id="{{buttonId}}" ng-click="openModal($event)">Click to specify</button>
        </div>

        <div class="divider clearfix"></div>

        <div class="col-md-11 text-left" ng-show="editLocations">
            <ul id="taglist" class="list-inline list-practice-area margin-b0">
                <li class="tags-box" ng-if = "location.isSelected && !location.hasChild" ng-repeat="location in linearLocations">{{location.loc_name}}</li>
                <a href="" class="fa fa-pencil" id="{{buttonId + '-edit'}}" ng-click="openModal($event)"></a>
            </ul>
        </div>

        <script type="text/ng-template" id="modal-locations-template.html">
            <div class="modal-header">
                <center>
                    <h3>{{heading|translate}}</h3>
                    <h5>{{subHeading|translate}}</h5>
                </center>
            </div>
            <div class="modal-body clearfix">
                <div class="modal-row custom-modal">
                    <div class="col-md-12">
                        <div class="" data-ng-repeat="region in data | orderBy: 'loc_ID'">
                            <span>
                                <i ng-hide="region.showChildLocations" ng-click="displayChildLocations(region)" class="fa fa-plus expand-collapse-button" aria-hidden="true"></i>
                            </span>
                            <span>
                                <i ng-hide="!region.showChildLocations" ng-click="hideChildLocations(region)" class="fa fa-minus expand-collapse-button" aria-hidden="true"></i>
                            </span>
                            <label class="ui-checkbox">
                                <input type="checkbox" ng-click="selectLocation($event , region , 2)" data="{{loc_ID}}" ng-checked="region.isSelected">
                                <span class="checkbox-group-heading">
                                    <strong>{{region.loc_name}}</strong>
                                </span>
                            </label>
                            <ul class=" practice-area-list clearfix" ng-show="region.showChildLocations">
                                <li data-ng-repeat="location in region.locations">
                                    <label class="ui-checkbox">
                                        <input type="checkbox" data="{{location.loc_ID}}" ng-click="selectLocation($event , location , 1)" ng-checked="location.isSelected">
                                        <span>{{location.loc_name}}</span>
                                    </label>
                                    <ul class=" sub-list clearfix">
                                        <li data-ng-repeat="sub in location.sub_areas">
                                            <label class="ui-checkbox">
                                                <input type="checkbox" ng-click="selectLocation($event , sub , 0)" ng-checked="sub.isSelected">
                                                <span>{{sub.loc_name}}</span>
                                            </label>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal-footer">
                <center>
                    <button class="btn btn-info" ng-click="save()">Save</button>
                    <button class="btn btn-gap-v btn-default" ng-click="cancel()">Cancel</button>
                </center>
            </div>
        </script>
    </div>
`;

function locationsModalController($scope, $modal, locationsService) {

  const toggleEditBehavior = (locations) => {
    $scope.editLocations = isAnyObjectSelected(locations);
  };

  const determineEditBehavior = (newPAvalue, oldPAvalue) => {
    if (!_.isEqual(newPAvalue, oldPAvalue)) toggleEditBehavior($scope.nestedLocations);
  }

  const updateLocationsModel = (locationsData) => {
    $scope.linearLocations = locationsData.linearLocations;
    $scope.nestedLocations = locationsData.nestedLocations;
  };

  const updateLocationsUI = (locationsData) => {
    let updatedData = {
      linearLocations: locationsService.linearize(locationsData.data),
      nestedLocations: locationsData.data
    };

    updateLocationsModel(updatedData);
    toggleEditBehavior(updatedData.linearLocations);
  };

  const stopEvents = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  const getLocationsModalData = () => {
    return {
      element: 'location',
      data: angular.copy($scope.nestedLocations)
    };
  };

  $scope.openModal = (event) => {
    stopEvents(event);

    let modalInstance = $modal.open({
      backdrop: 'static',
      templateUrl: "modal-locations-template.html",
      controller: 'ProfileModalCtrl',
      resolve: {
        data: () => getLocationsModalData()
      }
    });

    return modalInstance
      .result
      .then(updateLocationsUI);
  };

  $scope.$watch('nestedLocations', determineEditBehavior, true);
}

const getDefinationObject = () => {
  return {
    restrict: 'AE',
    replace: true,
    scope: {
      buttonId: '@',
      linearLocations: '=',
      nestedLocations: '=',
      onLocationsChange: '&'
    },
    template: locationsModalTemplate,
    controller: locationsModalController
  };
}

angular
  .module('app.directives')
  .directive('modalLocations', getDefinationObject);



// WEBPACK FOOTER //
// ./scripts/shared/directives/modal-locations.js